var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-form',{attrs:{"endpoint":"tipo-distancia","rota-base":"/admin/tipo-distancia","titulo-singular":"Tipo de Distância","campos-extras":[{"campo":"distancia_minima_km","label":"Distância mínima (km)","tipo":"string"},{"campo":"distancia_maxima_km","label":"Distância máxima (km)","tipo":"string"}]}})
}
var staticRenderFns = []

export { render, staticRenderFns }